import style from "./Registration-style.module.css";
import { useNavigate } from "react-router-dom";
import { resetRegisterdetails } from "../../stores/slices/einSlice";
import { resetSmartySteert } from "../../stores/slices/smartyStreetSlice";
import { useDispatch, useSelector } from "react-redux";
import { resetprivacyPolicycheckbox } from "../../stores/slices/registerSlice";
import { language } from "../../stores/slices/languageSlice";

const Successful = () => {
  const selectedLanguage = useSelector(language).Registrations.successful;
    let  dispatch= useDispatch()
    let navigate = useNavigate()
    const backtoLogin = () =>{
      dispatch(resetSmartySteert())
        dispatch(resetRegisterdetails())
        dispatch(resetprivacyPolicycheckbox())
        navigate('/')
    }
  return (
    <>

      <div
        className={`${style.basic_container} d-flex justify-content-center `}
      >
        <div className={`${style.basic_page}`}>
              <div className={style.tick}>✔</div>
          <div className="container pt-3">
            <p className={style.success}>
             {selectedLanguage?.successText}
            </p>
            <p className="pt-3">
            {selectedLanguage?.content}
            </p>
            <p onClick={backtoLogin} className={`p-3 mr-5 ${style.reg_link}`}>
            <u>{selectedLanguage?.backToLogin}</u>
          </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Successful;
